module.exports = __webpack_public_path__ + "static/media/main_img5.25726131.svg";